<template>
  <el-tabs v-model="currentTab" class="user-message">
    <el-tab-pane name="first">
      <div slot="label">
        <el-badge :is-dot="hasNotice">消息</el-badge>
      </div>
      <div v-if="!hasNotice" class="no-data" style="padding: 20px 0;">暂无消息</div>
      <div v-else class="list-wrap">
        <div class="item" v-for="item in getNotice.unreadVos" :key="item.id">
          <!-- <el-link type="primary" href="#">你有5条关于王益东的未读消息</el-link> -->
          <i class="dot red"></i>
          <el-link type="primary" @click="onNoticeClick(item)">{{ `你有${item.unreadNum}条关于${item.patientName}的未读消息` }}</el-link>
        </div>
      </div>
    </el-tab-pane>
    <el-tab-pane label="通知" name="second">
      <div slot="label">
        <el-badge :is-dot="hasMessage">通知</el-badge>
      </div>      
      <div v-if="!hasMessage" class="no-data" style="padding: 20px 0;">暂无通知</div>
      <div v-else class="list-wrap">
        <div class="item" v-for="item in getMessage" :key="item.id">
          <i v-if="!item.msgState" class="dot red"></i>
          <el-link type="primary" @click="onMessageClick(item)">{{ item.msgContent }}</el-link>
        </div>
      </div>      
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import api from '@/service/api';

export default {
  name: 'UserMessage',
  props: {
    // 是否定时刷新
    autoRefresh: {
      type: Boolean,
      default: false,      
    }
  },
  computed: {
    hasNotice() {
      return this.getNotice.totalUnreadNum > 0;
    },
    hasMessage() {
      return this.getMessage && this.getMessage.length > 0;
    },
    getMessage() {
      return this.$store.state.userMessage.message;
    },
    getNotice() {
      return this.$store.state.userMessage.notice;
    }
  },
	data(){
		return {
			isLoading: false,
      currentTab: 'first',
			hospitalCode:'YS_HM4'
		}
	},
	async created () {
    this.hospitalCode=await api.getHospitalCode();

    if (this.autoRefresh && this.hospitalCode!=='YS_HM4') {
      this.loadData(1);
      this.loadData(2);
      setInterval(_=>{
		this.loadData(1);
        this.loadData(2);
      }, 600*1000);
    }
	},
	methods: {
    loadData(v) {
      switch(v) {
        case 1:
          this.$store.dispatch('loadUserMessage');
          break;
        case 2:
          this.$store.dispatch('loadUserNotice').then(_=>{
            this.$emit('update', this.hasNotice || this.hasMessage);
          });
          break;
      }
    },
    onNoticeClick(item) {
      // 更新状态为已读
      api.updateUserNotice(item.recordId).then(_=>{
        // 重新加载数据
        this.loadData(2);
      });
      // 弹出新页面
			let url = `#/patient/user?patientId=${item.patientId}&t=3&t2=5&fid=${item.recordId}&datasources=${item.datasources}`;
			this.popWindow(url);  
    },
    onMessageClick(item) {
      // 更新状态为已读
      api.updateUserMessage(item.id).then(_=>{
        // 重新加载数据
        this.loadData(1);
      });
      // 弹出新页面
		let url = `#/patient/user?patientId=${item.patientId}&t=3&fid=${item.dataId}&datasources=${item.datasources}`;
		this.popWindow(url);
    },
    popWindow(url) {
			const tempLink = document.createElement('a');
			tempLink.style.display = 'none';
			tempLink.href = url;
			tempLink.target = '_blank';
			document.body.appendChild(tempLink);
			tempLink.click()
			document.body.removeChild(tempLink);      
    }
	}
}	
</script>

<style lang="less" scoped>
:deep(.el-badge__content) {
  top: 10px;
}
.list-wrap {
  max-height: 288px;
  overflow: hidden;
  overflow-y: auto;
}
</style>